import { string } from 'prop-types';

enum colorVariantMap {
  blue,
  green,
  purple,
  red,
  yellow,
}

enum pageVariantMap {
  'rsvp',
  'registry',
  'guest-list',
  'save-the-date',
}

const websiteFrameVariantsSrcMap = {
  golddeco: {
    blue: 'gold-deco-blue_image_v1.jpg',
    green: 'gold-deco-green_image_v1.jpg',
    purple: 'gold-deco-purple_image_v1.jpg',
    red: 'gold-deco-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  golddust: {
    blue: 'gold-dust-blue_image_v1.jpg',
    green: 'gold-dust-green_image_v1.jpg',
    purple: 'gold-dust-purple_image_v1.jpg',
    red: 'gold-dust-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  goldenhaze: {
    blue: 'golden-haze-blue_image_v1.jpg',
    green: 'golden-haze-green_image_v1.jpg',
    purple: 'reg.png',
    red: 'golden-haze-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  goldenhour: {
    blue: 'golden-hour-blue_image_v1.jpg',
    green: 'golden-hour-green_image_v1.jpg',
    purple: 'golden-hour-purple_image_v1.jpg',
    red: 'golden-hour-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  goldenstarburst: {
    blue: 'golden-starburst-blue_image_v1.jpg',
    green: 'golden-starburst-green_image_v1.jpg',
    purple: 'reg.png',
    red: 'golden-starburst-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  graphicsimplicity: {
    blue: 'graphic-simplicity-blue_image_v1.jpg',
    green: 'graphic-simplicity-green_image_v1.jpg',
    purple: 'graphic-simplicity-purple_image_v1.jpg',
    red: 'graphic-simplicity-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  inks: {
    blue: 'inks-blue_image_v1.jpg',
    green: 'ww-cross-rsvp.png',
    purple: 'inks-purple_image_v1.jpg',
    red: 'inks-red_image_v1.jpg',
    yellow: 'gl.png',
  },
  strunginloveframe: {
    blue: 'strung-in-love-frame-blue_image_v1.jpg',
    green: 'strung-in-love-frame-green_image_v1.jpg',
    purple: 'strung-in-love-frame-purple_image_v1.jpg',
    red: 'strung-in-love-frame-red_image_v1.jpg',
    yellow: 'gl.png',
  },
} as const;

const placementVariantMap = {
  bottom: string,
  top: string,
  bottomLeft: string,
  bottomRight: string,
  topLeft: string,
  topRight: string,
} as const;

const artVariantsSrcMap = {
  golddeco: {
    bottom: 'gold-deco-bottom_image_v1.png',
    top: 'gold-deco-top_image_v1.png',
  },
  golddust: {
    bottom: 'gold-dust-bottom_image_v1.png',
    top: 'gold-dust-top_image_v1.png',
  },
  goldenhaze: {
    bottom: 'henna-art.png',
  },
  goldenhour: {
    bottom: 'golden-hour-bottom_image_v1.png',
    top: 'golden-hour-top_image_v1.png',
  },
  goldenstarburst: {
    bottom: 'gold-starburst-bottom_image_v1.png',
    top: 'gold-starburst-top_image_v1.png',
  },
  graphicsimplicity: {
    bottomLeft: 'graphic-simplicity-bottom-left_image_v1.png',
    topLeft: 'graphic-simplicity-top-left.png',
    bottomRight: 'graphic-simplicity-bottom.png',
  },
  inkBlue: {
    bottom: 'blue-ink-bottom_image_v1.png',
    top: 'blue-ink-top_image_v1.png',
  },
  inkGreen: {
    bottom: 'green-ink-bottom_image_v1.png',
    top: 'green-ink-top_image_v1.png',
  },
  inkPurple: {
    bottom: 'purple-ink-bottom_image_v1.png',
    top: 'purple-ink-top_image_v1.png',
  },
  inkRed: {
    bottom: 'red-ink-bottom_image_v1.png',
    top: 'red-ink-top_image_v1.png',
  },
  strunginloveframe: {
    bottom: 'strung-in-love-bottom_image_v1.png',
    top: 'strung-in-love-top_image_v1.png',
  },
} as const;

const websiteFrameColorToArtMapping = {
  golddeco: {
    blue: 'golddeco',
    green: 'golddeco',
    purple: 'golddeco',
    red: 'golddeco',
    yellow: 'golddeco',
  },
  golddust: {
    blue: 'golddust',
    green: 'golddust',
    purple: 'golddust',
    red: 'golddust',
    yellow: 'golddust',
  },
  goldenhaze: {
    blue: 'goldenhaze',
    green: 'goldenhaze',
    purple: 'goldenhaze',
    red: 'goldenhaze',
    yellow: 'goldenhaze',
  },
  goldenhour: {
    blue: 'goldenhour',
    green: 'goldenhour',
    purple: 'goldenhour',
    red: 'goldenhour',
    yellow: 'goldenhour',
  },
  goldenstarburst: {
    blue: 'goldenstarburst',
    green: 'goldenstarburst',
    purple: 'goldenstarburst',
    red: 'goldenstarburst',
    yellow: 'goldenstarburst',
  },
  graphicsimplicity: {
    blue: 'graphicsimplicity',
    green: 'graphicsimplicity',
    purple: 'graphicsimplicity',
    red: 'graphicsimplicity',
    yellow: 'graphicsimplicity',
  },
  inks: {
    blue: 'inkBlue',
    green: 'inkGreen',
    purple: 'inkPurple',
    red: 'inkRed',
    yellow: 'inkRed',
  },
  strunginloveframe: {
    blue: 'strunginloveframe',
    green: 'strunginloveframe',
    purple: 'strunginloveframe',
    red: 'strunginloveframe',
    yellow: 'strunginloveframe',
  },
} as const;

export type WebsiteFrameVariant = keyof typeof websiteFrameVariantsSrcMap;
export type ColorVariant = keyof typeof colorVariantMap;
export type PageVariant = keyof typeof pageVariantMap;

export type ArtVariant = keyof typeof artVariantsSrcMap;
export type PlacementVariant = keyof typeof placementVariantMap;

export const getWebsiteFrameSrc = (variant: WebsiteFrameVariant, color: ColorVariant, page: PageVariant, image?: string) => {
  if (image) return image;
  return `sitewide/cross-sell_wedding-website/${page}/${websiteFrameVariantsSrcMap[variant][color]}`;
};

export const getWebsiteArtSrc = <T extends ArtVariant, P extends keyof (typeof artVariantsSrcMap)[T]>(variant: T, placement: P) => {
  return `common/art/${artVariantsSrcMap[variant][placement]}`;
};

export const getWebsiteArtVariant = (websiteFrameVariant: WebsiteFrameVariant, colorVariant: ColorVariant, pageVariant: PageVariant) => {
  const foundArtVariant: ArtVariant = websiteFrameColorToArtMapping[websiteFrameVariant][colorVariant];
  return artVariantsSrcMap[foundArtVariant];
};

const absolutePositionMap = {
  top: {
    top: '0px',
    left: '-21%',
    width: '68%',
    zIndex: 0,
  },
  bottom: {
    bottom: '0px',
    right: '-25%',
    width: '82%',
    zIndex: 0,
  },
  bottomLeft: {
    bottom: '0px',
    left: '0px',
  },
  bottomRight: {
    bottom: '0px',
    left: '0px',
  },
  topLeft: {
    top: '0px',
    left: '0px',
  },
  topRight: {
    top: '0px',
    right: '0px',
  },
} as const;

const absolutePositionRegistryMap = {
  top: {
    top: '0px',
    left: '0px',
    width: '68%',
    zIndex: 0,
  },
  bottom: {
    bottom: '0px',
    right: '-5%',
    width: '60%',
    zIndex: 0,
  },
  bottomLeft: {
    bottom: '0px',
    left: '0px',
  },
  bottomRight: {
    bottom: '0px',
    left: '0px',
  },
  topLeft: {
    top: '0px',
    left: '0px',
  },
  topRight: {
    top: '0px',
    right: '0px',
  },
} as const;

const absolutePositionMapForGraphicsimplicity = {
  top: {
    top: '0px',
    left: '0px',
    right: '0px',
  },
  bottom: {
    bottom: '0px',
    left: '0px',
    right: '0px',
  },
  bottomLeft: {
    bottom: '0px',
    left: '0px',
    height: 'auto',
    width: '50%',
    zIndex: 10,
  },
  bottomRight: {
    bottom: '0px',
    right: '4%',
    width: '4%',
    zIndex: 0,
  },
  topLeft: {
    top: '0px',
    left: '5%',
    height: 'auto',
    width: '4%',
    zIndex: 10,
  },
  topRight: {
    bottom: '0px',
    right: '0px',
    width: '0px',
  },
} as const;

const absolutePositionGuestListMap = {
  top: {
    top: '0px',
    left: '0px',
    right: '0px',
  },
  bottom: {
    bottom: '0px',
    left: '55%',
    transform: 'translateX(-50%)',
    zIndex: 0,
  },
  bottomLeft: {
    bottom: '0px',
    left: '0px',
  },
  bottomRight: {
    bottom: '0px',
    left: '0px',
  },
  topLeft: {
    top: '0px',
    left: '0px',
  },
  topRight: {
    top: '0px',
    right: '0px',
  },
} as const;

export type AbsolutePositionVariant = keyof typeof absolutePositionMap;

export const getAbsolutePosition = (placementVariant: PlacementVariant, frameVariant: WebsiteFrameVariant, pageVariant: PageVariant) => {
  switch (pageVariant) {
    case 'rsvp':
      return absolutePositionMap[placementVariant];
    case 'registry':
      return absolutePositionRegistryMap[placementVariant];
    case 'guest-list':
      return absolutePositionGuestListMap[placementVariant];
    default:
      return absolutePositionMapForGraphicsimplicity[placementVariant];
  }
};
